var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageUserChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.375 12.375H9.625C8.10622 12.375 6.875 13.6062 6.875 15.125V50.875C6.875 52.3938 8.10622 53.625 9.625 53.625H56.375C57.8938 53.625 59.125 52.3938 59.125 50.875V15.125C59.125 13.6062 57.8938 12.375 56.375 12.375Z",
    fill: "#D1E6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 12.375H56.375C57.8944 12.375 59.125 13.6056 59.125 15.125V20.625H6.875V15.125C6.875 13.6056 8.10563 12.375 9.625 12.375Z",
    fill: "#3987F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0036 35.8669C23.7446 35.8669 25.1558 34.4556 25.1558 32.7147C25.1558 30.9738 23.7446 29.5625 22.0036 29.5625C20.2627 29.5625 18.8515 30.9738 18.8515 32.7147C18.8515 34.4556 20.2627 35.8669 22.0036 35.8669Z",
    fill: "#3987F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5092 42.6246C24.1752 42.6246 19.8199 42.6246 17.4892 42.6246C16.5886 42.6246 15.908 41.7652 16.1624 40.899C16.898 38.3724 19.2355 36.6777 22.0027 36.6777C24.7699 36.6777 27.1039 38.3724 27.843 40.899C28.0974 41.7652 27.4167 42.6246 26.5161 42.6246H26.5092Z",
    fill: "#3987F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3237 40.8339L50.4127 33.8292C51.0977 33.0412 51.0142 31.847 50.2262 31.162C49.4381 30.4769 48.244 30.5605 47.559 31.3485L41.4699 38.3531C40.7849 39.1412 40.8684 40.3353 41.6564 41.0204C42.4445 41.7054 43.6386 41.6219 44.3237 40.8339Z",
    fill: "#3987F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2291 38.2581L40.0969 34.1259C39.3586 33.3876 38.1615 33.3876 37.4232 34.1259C36.6848 34.8643 36.6848 36.0613 37.4232 36.7997L41.5553 40.9318C42.2937 41.6702 43.4908 41.6702 44.2291 40.9318C44.9674 40.1935 44.9674 38.9964 44.2291 38.2581Z",
    fill: "#3987F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageUserChoice);
export default __webpack_public_path__ + "static/media/icon_page_user_choice.fa6f25f2.svg";
export { ForwardRef as ReactComponent };